module.exports = __webpack_public_path__ + "static/media/stoptrans.7cc18770.svg";